/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";

const AssignCoursePopup = ({
  selectedFaqId = null,
  setSelectedFaqId = () => {},
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const { t } = useTranslation();

  const [courseLoading, setCourseLoading] = useState(false);
  const [courseList, setCourseList] = useState([]);
  const [faqCourses, setFaqCourses] = useState([]);

  const [courseName, setCourseName] = useState("");

  const [checkedCourses, setCheckedCourses] = useState({}); // To store checked state

  const [isSaving, setisSaving] = useState(false);

  const [validation, setValidation] = useState({
    courseError: false,
  });

  //validation function
  const validationHandler = () => {
    let isValid = true;

    if (faqCourses.length === 0) {
      setValidation((prevState) => ({ ...prevState, titleError: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get course list
  const getAllCourseList = async (isLoading = false, courseString = "") => {
    try {
      if (isLoading) {
        setCourseLoading(true);
      }

      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_COURSE_RECORDS +
        `?token=${token}&modulefrom=backend&limit=50`;

      if (courseString !== "") {
        requestURL += `&filtertitle=${courseString}`;
      }

      const response = await getData(requestURL);

      setCourseLoading(false);

      console.log(response);

      if (response.status) {
        setCourseList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for check expert
  const courseCheckHandler = (courseId, isChecked) => {
    setCheckedCourses((prevState) => ({
      ...prevState,
      [courseId]: isChecked, // Update checked state for the specific expert
    }));

    if (isChecked) {
      // Add to faqExperts if checked, if not already there
      if (!faqCourses.includes(courseId)) {
        setFaqCourses((prevState) => [...prevState, courseId]);
      }
    } else {
      // Remove from faqExperts if unchecked
      setFaqCourses((prevState) => prevState.filter((id) => id !== courseId));
    }
  };

  //get faq details
  const getFaqDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_FAQ_DETAILS +
        `/${selectedFaqId}?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        const data = response.data;

        if (data.courseids && data.courseids.length > 0) {
          for (let courseId of data.courseids) {
            courseCheckHandler(courseId, true);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save faq function
  const saveFaqHandler = async (e) => {
    if (validationHandler()) {
      try {
        setisSaving(true);

        let apiData = {
          courseids: faqCourses,
        };

        let requestURL = url.API_BASE_URL;

        let response = {};

        if (selectedFaqId) {
          requestURL += url.API_UPDATE_FAQ + `/${selectedFaqId}?token=${token}`;

          response = await putData(requestURL, apiData);
        }

        setisSaving(false);

        console.log(response);

        if (response.status) {
          // close the popup
          let offCanvasPopup = document.querySelector("#offcanvasAssignCourse");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();

          resetHandler();
          afterPopupClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const resetHandler = () => {
    setCourseList([]);
    setFaqCourses([]);
    setCourseName("");
    setCheckedCourses({});
    setSelectedFaqId(null);

    setValidation({
      courseError: false,
    });
  };

  useEffect(() => {
    if (selectedFaqId) {
      getAllCourseList(true);
      getFaqDetails();
    }
  }, [selectedFaqId]);

  useEffect(() => {
    if (courseName !== "" && courseName.length > 0) {
      const filterSearch = courseList.filter((course) =>
        course.title.toLowerCase().includes(courseName.toLowerCase())
      );

      if (filterSearch.length === 0) {
        getAllCourseList(false, courseName);
      }
    } else {
      const timeoutId = setTimeout(() => {
        getAllCourseList(false);
      }, 500); // Debounce the input for better UX
      return () => clearTimeout(timeoutId);
    }
  }, [courseName]);

  // Filtered list based on search input if length > 2
  const filteredCourses =
    courseName.length > 2
      ? courseList.filter((course) =>
          course.title.toLowerCase().includes(courseName.toLowerCase())
        )
      : courseList;

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasAssignCourse"
      aria-labelledby="offcanvasAssignCourseLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              school
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasAssignCourseLabel"
            >
              {t("Assign Courses")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage courses for this FAQ")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="search position-relative">
                  <button className="d-block position-absolute top-50 border-0 text-primary material-symbols-outlined bg-transparent ms-3 translate-middle-y">
                    search
                  </button>
                  <input
                    type="text"
                    className="form-control fs-sm shadow-none border border-gray-300 ps-5"
                    placeholder="Search course by name"
                    id="courseSearch"
                    value={courseName}
                    onChange={(e) => setCourseName(e.target.value)}
                  />
                  {validation.courseError && (
                    <div className="text-danger mt-2">
                      Please select at least one course.
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Courses")}
                </label>
                <ul
                  className="experts list-unstyled mb-0"
                  id="appcourses"
                  style={{ maxHeight: "250px", overflowY: "auto" }}
                >
                  {courseLoading
                    ? [1, 2, 3, 4].map((_, index) => (
                        <li
                          key={index}
                          className="px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200"
                        >
                          <div className="placeholder-glow w-100">
                            <span
                              className="placeholder col-2 me-2 rounded-circle"
                              style={{ width: "2.2rem", height: "2.2rem" }}
                            ></span>
                            <span className="placeholder col-6"></span>
                          </div>
                        </li>
                      ))
                    : filteredCourses.map((course) => (
                        <li
                          key={course._id}
                          className="expert-item px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200 bg-white rounded-3 transition"
                        >
                          <input
                            type="checkbox"
                            className="form-check-input flex-shrink-0 border-2 shadow-none m-0 me-2"
                            id={`expert_checkbox_${course._id}`}
                            checked={!!checkedCourses[course._id]}
                            value={course._id}
                            onChange={(e) =>
                              courseCheckHandler(course._id, e.target.checked)
                            }
                          />
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              {course.title}
                            </p>
                          </div>
                        </li>
                      ))}
                </ul>
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveFaqHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Faq")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignCoursePopup;
